import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  /** Upload UI content */
  children: React.ReactNode;
};

/**
 * Presentational org logo upload step.
 * Renders heading/description with logo upload content passed as children.
 */
export function OrgLogoStep({ children }: Props) {
  return (
    <div className="flex-1 flex flex-col gap-6 p-6">
      <Type variant="h2">Organization Logo</Type>

      <div className="flex-1 flex flex-col justify-center gap-6">
        <Type variant="body1" className="text-brand-700">
          Add your organization's logo. We may use this logo for marketing purposes.
        </Type>

        {children}
      </div>
    </div>
  );
}

export default OrgLogoStep;
